import { type EditorPlugin } from '../../types/aha-editor';

export const ImageSchemaPlugin: EditorPlugin = {
  name: 'Image Schema plugin',
  schema: {
    image: {
      isInline: true,
      isVoid: true,
    },
  },
};

export const AudioSchemaPlugin: EditorPlugin = {
  name: 'Audio Schema plugin',
  schema: {
    audio: {
      isInline: true,
      isVoid: true,
    },
  },
};

export const VideoSchemaPlugin: EditorPlugin = {
  name: 'Video Schema plugin',
  schema: {
    video: {
      isInline: true,
      isVoid: true,
    },
  },
};

export const AttachmentSchemaPlugin: EditorPlugin = {
  name: 'Attachment Schema plugin',
  schema: {
    attachment: {
      isInline: true,
      isVoid: true,
    },
  },
};
